import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useCurrentUserIdAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

export function useTrackQRCodeDownload(): (data: { shareId: string | null | undefined }) => Promise<void> {
	const {
		data: {
			petition: {
				id: petitionId,
				user: { id: userId },
			},
		},
	} = usePetitionDetailsPageData();
	const sourceLocation = useQueryParamValue('source_location');
	const currentUserState = useCurrentUserIdAsync();
	const currentUserId = isLoaded(currentUserState) ? currentUserState.value : undefined;
	const track = useTracking();

	return useCallback(
		async ({ shareId }: { shareId: string | null | undefined }) => {
			await track('share_petition', {
				location: 'qr_code_download',
				view_context: 'petition_details',
				own_petition: userId === currentUserId,
				context: 'petition_details',
				petition_id: `petition_${petitionId}`,
				source_location: sourceLocation,
				...(shareId != null ? { generated_share_id: shareId, generated_share_id_source: 'qr_code_server' } : {}),
			});
		},
		[track, petitionId, userId, currentUserId, sourceLocation],
	);
}
